export default "__VITE_ASSET__xcfPxNcD__"